/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IRRInvestment } from './IRRInvestment';
import {
    IRRInvestmentFromJSON,
    IRRInvestmentFromJSONTyped,
    IRRInvestmentToJSON,
} from './IRRInvestment';
import type { IRRPeriod } from './IRRPeriod';
import {
    IRRPeriodFromJSON,
    IRRPeriodFromJSONTyped,
    IRRPeriodToJSON,
} from './IRRPeriod';

/**
 * 
 * @export
 * @interface InternalRateOfReturnViewModel
 */
export interface InternalRateOfReturnViewModel {
    /**
     * 
     * @type {string}
     * @memberof InternalRateOfReturnViewModel
     */
    clientName: string;
    /**
     * 
     * @type {string}
     * @memberof InternalRateOfReturnViewModel
     */
    compiledBy: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalRateOfReturnViewModel
     */
    compiledTimestamp: Date;
    /**
     * 
     * @type {Array<IRRPeriod>}
     * @memberof InternalRateOfReturnViewModel
     */
    requiredPeriods?: Array<IRRPeriod>;
    /**
     * 
     * @type {Date}
     * @memberof InternalRateOfReturnViewModel
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalRateOfReturnViewModel
     */
    endDate?: Date;
    /**
     * 
     * @type {Array<IRRInvestment>}
     * @memberof InternalRateOfReturnViewModel
     */
    iRRInvestments: Array<IRRInvestment>;
}

/**
 * Check if a given object implements the InternalRateOfReturnViewModel interface.
 */
export function instanceOfInternalRateOfReturnViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "compiledBy" in value;
    isInstance = isInstance && "compiledTimestamp" in value;
    isInstance = isInstance && "iRRInvestments" in value;

    return isInstance;
}

export function InternalRateOfReturnViewModelFromJSON(json: any): InternalRateOfReturnViewModel {
    return InternalRateOfReturnViewModelFromJSONTyped(json, false);
}

export function InternalRateOfReturnViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalRateOfReturnViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientName': json['ClientName'],
        'compiledBy': json['CompiledBy'],
        'compiledTimestamp': (new Date(json['CompiledTimestamp'])),
        'requiredPeriods': !exists(json, 'RequiredPeriods') ? undefined : ((json['RequiredPeriods'] as Array<any>).map(IRRPeriodFromJSON)),
        'startDate': !exists(json, 'StartDate') ? undefined : (new Date(json['StartDate'])),
        'endDate': !exists(json, 'EndDate') ? undefined : (new Date(json['EndDate'])),
        'iRRInvestments': ((json['IRRInvestments'] as Array<any>).map(IRRInvestmentFromJSON)),
    };
}

export function InternalRateOfReturnViewModelToJSON(value?: InternalRateOfReturnViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientName': value.clientName,
        'CompiledBy': value.compiledBy,
        'CompiledTimestamp': (value.compiledTimestamp.toISOString()),
        'RequiredPeriods': value.requiredPeriods === undefined ? undefined : ((value.requiredPeriods as Array<any>).map(IRRPeriodToJSON)),
        'StartDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'EndDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'IRRInvestments': ((value.iRRInvestments as Array<any>).map(IRRInvestmentToJSON)),
    };
}

